<template>
  <span
    class="rounded-md py-1 px-2 text-sm"
    :style="`background-color:${backgroundColor};color:${textColor};`"
  >
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    backgroundColor: {
      default: '#D1D5DB',
      type: String
    },
    textColor: {
      default: '#FFFFFF',
      type: String
    }
  }
}
</script>
